export const enum ProductGroupsTableColumnsEnum {
    Type = 'type',
    Name = 'name',
    Products = 'products',
    UpdatedAt = 'updatedAt',
    Services = 'services',
    Status = 'status',
    Actions = 'actions',
}
